import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { FolderType } from '../constants';

export const useLogClickMoveGoodsToOtherFolder = (folderType: FolderType) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'CLICK_MOVE_GOODS_TO_OTHER_FOLDER',
      analytics: { FOLDER_TYPE: folderType },
    });
  }, [logAnalyticsEvent, folderType]);
};
